"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PreviewImpl = void 0;
const tslib_1 = require("tslib");
/// <reference path="Preview.d.ts" />
const $ = require("jquery");
const Utilities_1 = require("../../javascript/Utilities");
require("../../less/Preview.less");
const Base_1 = require("../../model/Base");
require("../PropertyPage/PropertyPage");
const WorkflowModel_1 = require("../Workflow/WorkflowModel");
let _ = require("underscore");
const _PreviewPrivateDataKeys = ["requestInstanceTimeoutId", "requestDelay", "tabData", "selectedType", "page", "pageCount"];
const _LegacyBrowserFullScreenRequested = function (id) {
    window.open("LegacyPreview.html?id=" + id, "_newtab", "fullscreen=yes");
};
class PreviewImpl {
    static initAsync($elem, options) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            let synData = PreviewImpl.getData($elem);
            if (synData)
                throw "Preview already initialized.";
            else {
                synData = $.extend({}, PreviewImpl.DefaultOptions, options);
                PreviewImpl.setData($elem, synData);
                $(document).on("webkitfullscreenchange mozfullscreenchange fullscreenchange MSFullscreenChange", function (event) {
                    let inFullScreen = document.fullScreen || document.mozFullScreen || document.webkitIsFullScreen || document.msFullscreenElement;
                    if (inFullScreen)
                        $elem.find("a.fullscreen").find("i").attr("class", "fa fa-times");
                    else
                        $elem.find("a.fullscreen").find("i").attr("class", "fa fa-arrows-alt");
                });
                PreviewImpl.setPrivateData($elem, "requestDelay", 250);
                // eslint-disable-next-line no-null/no-null
                PreviewImpl.setPrivateData($elem, "selectedType", null);
                PreviewImpl.setPrivateData($elem, "tabData", []);
                PreviewImpl.setPrivateData($elem, "fullScreenMode", false);
                PreviewImpl.createTabStrip($elem);
                $elem.addClass("synPreview");
                if (synData.id)
                    yield PreviewImpl.setInstanceAsync($elem, synData.id, synData.editable);
                else
                    $elem.find(".synTabStrip").hide();
            }
        });
    }
    static setInstanceAsync($elem, id, editable) {
        const synData = PreviewImpl.getData($elem);
        const editableOldValue = synData.editable;
        const idOldValue = synData.id;
        return new Promise((resolve) => {
            synData.editable = editable || false;
            synData.id = id;
            let timeoutId = PreviewImpl.getPrivateData($elem, "requestInstanceTimeoutId");
            if (typeof timeoutId !== "undefined") {
                window.clearTimeout(timeoutId);
                const idCompare = synData.id;
                if (idCompare === id && idOldValue) {
                    synData.editable = editableOldValue;
                    synData.id = idOldValue;
                    resolve(false);
                }
            }
            const requestDelay = PreviewImpl.getPrivateData($elem, "requestDelay");
            timeoutId = window.setTimeout(() => tslib_1.__awaiter(this, void 0, void 0, function* () {
                yield PreviewImpl.requestInstanceAsync($elem, id);
                PreviewImpl.deletePrivateData($elem, "requestInstanceTimeoutId");
                resolve(true);
            }), requestDelay);
            PreviewImpl.setPrivateData($elem, "requestInstanceTimeoutId", timeoutId);
        });
    }
    static recreateAsync($elem) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const synData = PreviewImpl.getData($elem);
            if (synData === null || synData === void 0 ? void 0 : synData.id)
                yield PreviewImpl.setInstanceAsync($elem, synData.id, synData.editable);
        });
    }
    static resize($elem) {
        return $elem.each((_idx, elem) => {
            const $this = $(elem);
            const fullScreenMode = PreviewImpl.getPrivateData($this, "fullScreenMode");
            if (fullScreenMode) {
                // Tabstriphöhe anpassen
                let $tabStrip = $this.find(".synTabStrip");
                let newTabStripHeight = $tabStrip.parent().innerHeight();
                let newTabStripContentHeight = newTabStripHeight - ($tabStrip.find(".k-tabstrip-items").outerHeight(true));
                $tabStrip.css("height", $tabStrip.parent().innerHeight() + "px");
                $tabStrip.find(".k-content").css("height", newTabStripContentHeight + "px");
                $this.find(".iviewer_cursor").css("height", newTabStripContentHeight + "px");
            }
            PreviewImpl.imageControlAsync($this, $this.find(".iviewer_cursor"), "update").then(() => {
                PreviewImpl.imageControlAsync($this, $this.find(".iviewer_cursor"), "fit");
            });
        });
    }
    static clearView($elem) {
        return $elem.each((_idx, elem) => {
            const $this = $(elem);
            const synData = PreviewImpl.getData($this);
            delete synData.id;
            $this.find(".synTabStrip").hide();
        });
    }
    static destroy($elem) {
        return $elem.each((_idx, elem) => {
            $(elem)
                .off("beginInit")
                .off("initSuccess")
                .off("endInit")
                .off("instanceLoaded")
                .removeData("synPreview")
                .removeClass("synPreview")
                .removeData(_PreviewPrivateDataKeys)
                .html("");
        });
    }
    static getPropertyPage($elem) {
        if (PreviewImpl.getPrivateData($elem, "tabData")) {
            let tabStrip = $elem.find(".synTabStrip").data("kendoTabStrip");
            let currentIndex = PreviewImpl.getTabIndexByName($elem, "Propertypage");
            let contentHolder = tabStrip.contentHolder(currentIndex);
            return $(contentHolder).find(".synPropertyPage");
        }
    }
    static isEditable($elem) {
        return PreviewImpl.getData($elem).editable;
    }
    static update($elem, instances) {
        return $elem.each((_idx, elem) => {
            const $this = $(elem);
            const synData = PreviewImpl.getData($this);
            if (synData) {
                if (synData.id && $.grep(instances, inst => inst.id.value === synData.id).length)
                    PreviewImpl.recreateAsync($this);
            }
        });
    }
    static delete($elem, instances) {
        return $elem.each((_idx, elem) => {
            const $this = $(elem);
            const synData = PreviewImpl.getData($this);
            if (synData) {
                if (synData.id && $.grep(instances, inst => inst.id.value === synData.id).length)
                    PreviewImpl.clearView($this);
            }
        });
    }
    static getTabItemByIndex($elem, index) {
        const tabData = PreviewImpl.getPrivateData($elem, "tabData");
        return tabData[index];
    }
    static showTabContent($elem, index) {
        if (index < 0)
            return;
        const synData = PreviewImpl.getData($elem);
        const tabData = PreviewImpl.getPrivateData($elem, "tabData");
        if (tabData) {
            let currentTab = tabData[index];
            let currentType = currentTab.name;
            let tabStrip = $elem.find(".synTabStrip").data("kendoTabStrip");
            let $contentHolder = $(tabStrip.contentHolder(index));
            let id = synData.id;
            const page = 1;
            const pageCount = currentTab.pageCount || 1;
            PreviewImpl.setPrivateData($elem, "page", page);
            PreviewImpl.setPrivateData($elem, "pageCount", pageCount);
            switch (currentType) {
                case "Propertypage":
                    if (synData.editable) {
                        $contentHolder.find(".synPropertyPage")
                            .off("valuesChanged").on("valuesChanged", () => {
                            $elem.trigger("propertyPageValuesChanged");
                        })
                            .off("valuesReverted").on("valuesReverted", () => {
                            $elem.trigger("propertyPageValuesReverted");
                        })
                            .off("versionChanged").on("versionChanged", (_evt, options) => {
                            $elem.trigger("propertyPageVersionChanged", options);
                        })
                            .off("needsFullRefresh").on("needsFullRefresh", (_evt, typeId) => {
                            $elem.trigger("propertyPageNeedsFullRefresh", [typeId]);
                        })
                            .off("instanceChanged").on("instanceChanged", (_evt, instance) => {
                            $elem.trigger("instanceChanged", instance);
                        })
                            .synPropertyPage("setInstance", {
                            id: synData.id,
                            mode: Base_1.PropertyPageMode.Edit,
                            showVersions: true,
                            overrideInitialMode: true
                        });
                        PreviewImpl.createControls($elem, $contentHolder, currentType);
                    }
                    else {
                        $contentHolder.find(".synPropertyPage")
                            .off("valuesChanged")
                            .off("valuesReverted")
                            .off("versionChanged")
                            .off("needsFullRefresh")
                            .off("instanceChanged")
                            .synPropertyPage("setInstance", {
                            id: synData.id,
                            mode: Base_1.PropertyPageMode.View,
                            showVersions: true,
                            overrideInitialMode: true
                        });
                    }
                    break;
                case "Standard":
                    $elem.find(".previewError").addClass("hide");
                    $elem.find(".synTabStrip, .previewButtons").removeClass("hide");
                    Utilities_1.synUtil.getAJAXData({
                        url: Utilities_1.synUtil.getWSUrl("InstancePreviewTypes") + id + "/Standard/single?csrfToken=" + Utilities_1.synUtil.requestVerificationToken,
                        done: (result) => {
                            if (result.length > 0) {
                                const $div = $("<div></div>").appendTo($contentHolder.html(""));
                                if (result[0].isPlaintext) {
                                    const $jPreviewable = $("<div></div>")
                                        .addClass("jpreviewable")
                                        .appendTo($div);
                                    $("<pre></pre>")
                                        .css({
                                        "white-space": "pre-wrap",
                                        "word-wrap": "break-word"
                                    })
                                        .text(result[0].content)
                                        .appendTo($jPreviewable);
                                }
                                else
                                    $div.html(result[0].content);
                                PreviewImpl.createControls($elem, $contentHolder, currentType);
                            }
                        },
                        fail: () => {
                            $elem.find(".previewError").removeClass("hide");
                            $elem.find(".synTabStrip, .previewButtons").addClass("hide");
                        }
                    });
                    break;
                case "Content":
                    let imageDiv = $contentHolder.find("> .imageContentContainer");
                    let prodSysDiv = $contentHolder.find("> .prodSysContentContainer");
                    prodSysDiv.find(".workflowMapPane").remove();
                    if (currentTab.isWorkFlow) {
                        let wfPane = $("<div class='synPane workflowMapPane' />").appendTo(prodSysDiv);
                        Utilities_1.synUtil.getAJAXData({
                            method: "POST",
                            url: Utilities_1.synUtil.getWSUrl("WorkflowGetInstance"),
                            requestData: JSON.stringify({ id: id, checkout: false }),
                            done: function (workflow) {
                                if (workflow) {
                                    let workflowModel = WorkflowModel_1.WorkflowModel.fromJSON(workflow);
                                    wfPane.synWorkflow();
                                    wfPane.synWorkflow("viewWorkflow", workflowModel, true, true);
                                    PreviewImpl.createControls($elem, $contentHolder, currentType, wfPane);
                                }
                            },
                            fail: function (jqXHR, textStatus, errorThrown, url) {
                                Utilities_1.synUtil.getAJAXDataFail(jqXHR, textStatus, errorThrown, url, false);
                                PreviewImpl.createControls($elem, $contentHolder, currentType);
                            }
                        });
                    }
                    else {
                        PreviewImpl.imageControlAsync($elem, imageDiv, "loadImage", Utilities_1.synUtil.getWSUrl("InstancePreview") + id + "/" + page + "?csrfToken=" + Utilities_1.synUtil.requestVerificationToken)
                            .then(() => {
                            PreviewImpl.imageControlAsync($elem, imageDiv, "fit");
                        });
                        PreviewImpl.createControls($elem, $contentHolder, currentType);
                    }
                    break;
            }
        }
    }
    static getTabIndexByName($elem, name) {
        const tabData = PreviewImpl.getPrivateData($elem, "tabData");
        let index = -1;
        if (tabData) {
            _.each(tabData, function (item, idx) {
                if (item.name === name) {
                    index = idx;
                    return false;
                }
            });
        }
        return index;
    }
    static setPage($elem) {
        const page = PreviewImpl.getPrivateData($elem, "page");
        const pageCount = PreviewImpl.getPrivateData($elem, "pageCount");
        $elem.find(".previewHeadingText").removeClass("hide").text(page + " / " + pageCount);
    }
    static createTabStrip($elem) {
        let tabData = PreviewImpl.getPrivateData($elem, "tabData");
        let synData = PreviewImpl.getData($elem);
        let $tabStrip = $("<div class='synTabStrip'></div>");
        let tabStrip;
        let $warning = $("<div class='previewError hide'>" + Utilities_1.synUtil.Strings.getValue("preview.error") + "</div>");
        _.each(synData.allowedTypes, function (name, idx) {
            tabData.push({
                name: name,
                content: "",
                caption: Utilities_1.synUtil.Strings.getValue("preview." + name.toLowerCase()),
                pageCount: NaN,
                isPlaintext: false,
                isWorkFlow: false,
            });
        });
        $tabStrip.kendoTabStrip({
            dataContentField: "content",
            dataTextField: "caption",
            animation: false,
        });
        let dataSource = new kendo.data.DataSource({
            data: tabData
        });
        $tabStrip.data("kendoTabStrip").setDataSource(dataSource);
        if (_.contains(synData.allowedTypes, "Propertypage")) {
            let $propertyPage = $("<div class='synPropertyPage'></div>");
            $propertyPage.synPropertyPage({
                layout: (Utilities_1.synUtil.clientDeviceClass === "desktop") ? "absolute" : "table",
                tabindexOffset: 10000,
                checkForUnsavedChanges: synData.propertyPageCheckForUnsavedChanges
            });
            $tabStrip.data("kendoTabStrip").contentHolder(PreviewImpl.getTabIndexByName($elem, "Propertypage")).append($propertyPage);
        }
        if (_.contains(synData.allowedTypes, "Content")) {
            let div = $("<div style='position:relative;width:100%;height:" + (($(window).height()) - 75) + "px' class='text-center imageContentContainer'></div>");
            let opts = {
                src: "assets/images/loading_image.gif",
                ui_disabled: true,
                zoom_animation: false,
                mousewheel: true,
                zoom: "fit",
                onFinishLoad(e, u) {
                    PreviewImpl.imageControlAsync($elem, div, "update")
                        .then(() => {
                        PreviewImpl.imageControlAsync($elem, div, "fit");
                    });
                }
            };
            if (!synData.controls) {
                opts.mousewheel = false;
                opts.onStartDrag = function (e, u) { e.preventDefault(); };
                opts.onDrag = function (e, u) { e.preventDefault(); };
                opts.onStopDrag = function (e, u) { e.preventDefault(); };
                opts.onMouseMove = function (e, u) { e.preventDefault(); };
                opts.onClick = function (e, u) { e.preventDefault(); };
                opts.angle = function (e, u) { e.preventDefault(); };
            }
            PreviewImpl.imageControlAsync($elem, div, "init", opts);
            div.append($("<div style=\"background-color:white;position:absolute;bottom:0px;left:0;right:0;margin-left:auto;margin-right:auto;text-align:center;\"></div>"));
            let pageDiv = $("<div style=\"font-weight:bold;background-color:white;position:absolute;top:0px;left:0px;\"></div>").appendTo(div);
            pageDiv.append($("<span />"));
            $tabStrip.data("kendoTabStrip").contentHolder(PreviewImpl.getTabIndexByName($elem, "Content")).html("").append(div);
            let prodSysContentDiv = $("<div style='position:relative;width:100%;height:100%' class='text-center prodSysContentContainer'></div>");
            prodSysContentDiv.insertAfter(div);
            prodSysContentDiv.hide();
        }
        $elem.append($warning);
        $elem.append($tabStrip);
        tabStrip = $tabStrip.data("kendoTabStrip");
        tabStrip.disable(tabStrip.tabGroup.children());
    }
    static createControls($elem, $contentHolder, type, $workflowPane = undefined) {
        const synData = PreviewImpl.getData($elem);
        let buttons = [];
        let imageDiv = $contentHolder.find("> .imageContentContainer");
        let prodSysDiv = $contentHolder.find("> .prodSysContentContainer");
        $elem.find(".previewButtons").remove();
        let page = PreviewImpl.getPrivateData($elem, "page");
        let pageCount = PreviewImpl.getPrivateData($elem, "pageCount");
        if (synData.controls) {
            switch (type) {
                case "Content":
                    if ($workflowPane) {
                        imageDiv.hide();
                        prodSysDiv.show();
                    }
                    else {
                        prodSysDiv.hide();
                        imageDiv.show();
                        PreviewImpl.setPage($elem);
                        buttons = [
                            {
                                img: "fa-arrow-left",
                                tooltip: "Seite zurück",
                                // visibility: "hidden",
                                disabled: page === 1,
                                onclick() {
                                    if (page > 1) {
                                        $(this).removeAttr("disabled");
                                        $(this).next().removeAttr("disabled");
                                        page -= 1;
                                        PreviewImpl.setPrivateData($elem, "page", page);
                                        if (page === 1)
                                            $(this).attr("disabled", "disabled");
                                        PreviewImpl.setPage($elem);
                                        const requestDelay = PreviewImpl.getPrivateData($elem, "requestDelay");
                                        let requestInstanceTimeoutId = PreviewImpl.getPrivateData($elem, "requestInstanceTimeoutId");
                                        if (requestInstanceTimeoutId)
                                            window.clearTimeout(requestInstanceTimeoutId);
                                        requestInstanceTimeoutId = window.setTimeout(() => tslib_1.__awaiter(this, void 0, void 0, function* () {
                                            yield PreviewImpl.imageControlAsync($elem, imageDiv, "loadImage", Utilities_1.synUtil.getWSUrl("InstancePreview") + synData.id + "/" + page + "?csrfToken=" + Utilities_1.synUtil.requestVerificationToken);
                                            window.clearTimeout(requestInstanceTimeoutId);
                                        }), requestDelay);
                                        PreviewImpl.setPrivateData($elem, "requestInstanceTimeoutId", requestInstanceTimeoutId);
                                    }
                                }
                            },
                            {
                                img: "fa-arrow-right",
                                tooltip: "Seite vor",
                                disabled: pageCount === 1,
                                onclick() {
                                    if (page < pageCount) {
                                        $(this).removeAttr("disabled");
                                        $(this).prev().removeAttr("disabled");
                                        page += 1;
                                        PreviewImpl.setPrivateData($elem, "page", page);
                                        if (page === pageCount)
                                            $(this).attr("disabled", "disabled");
                                        PreviewImpl.setPage($elem);
                                        const requestDelay = PreviewImpl.getPrivateData($elem, "requestDelay");
                                        let requestInstanceTimeoutId = PreviewImpl.getPrivateData($elem, "requestInstanceTimeoutId");
                                        if (requestInstanceTimeoutId)
                                            window.clearTimeout(requestInstanceTimeoutId);
                                        requestInstanceTimeoutId = window.setTimeout(() => tslib_1.__awaiter(this, void 0, void 0, function* () {
                                            yield PreviewImpl.imageControlAsync($elem, imageDiv, "loadImage", Utilities_1.synUtil.getWSUrl("InstancePreview") + synData.id + "/" + page + "?csrfToken=" + Utilities_1.synUtil.requestVerificationToken);
                                            window.clearTimeout(requestInstanceTimeoutId);
                                        }), requestDelay);
                                        PreviewImpl.setPrivateData($elem, "requestInstanceTimeoutId", requestInstanceTimeoutId);
                                    }
                                }
                            },
                            {
                                img: "fa-expand",
                                visibility: true,
                                tooltip: "1:1",
                                onclick() {
                                    PreviewImpl.imageControlAsync($elem, imageDiv, "set_zoom", "100");
                                }
                            },
                            {
                                img: "fa-compress",
                                visibility: true,
                                tooltip: "Auf Seite anpassen",
                                onclick() {
                                    PreviewImpl.imageControlAsync($elem, imageDiv, "fit");
                                }
                            },
                            {
                                img: "fa-search-plus",
                                visibility: true,
                                tooltip: "Vergrößern",
                                onclick() {
                                    PreviewImpl.imageControlAsync($elem, imageDiv, "zoom_by", 1);
                                }
                            },
                            {
                                img: "fa-search-minus",
                                visibility: true,
                                tooltip: "Verkleinern",
                                onclick() {
                                    PreviewImpl.imageControlAsync($elem, imageDiv, "zoom_by", -1);
                                }
                            },
                            {
                                cssClass: "fullscreen",
                                img: "fa-arrows-alt",
                                tooltip: "Fullscreen",
                                visibility: Utilities_1.synUtil.clientDeviceClass === "desktop" ? true : false,
                                onclick() {
                                    // Hack to identify IE10 (Before: All IE versions below 11)
                                    const fullScreenMode = PreviewImpl.getPrivateData($elem, "fullScreenMode");
                                    if (navigator.appVersion.indexOf("MSIE 10") !== -1) {
                                        _LegacyBrowserFullScreenRequested(synData.id);
                                        PreviewImpl.setPrivateData($elem, "fullScreenMode", !fullScreenMode);
                                    }
                                    else {
                                        if (Utilities_1.synUtil.clientDeviceClass === "tablet")
                                            PreviewImpl.setPrivateData($elem, "fullScreenMode", !fullScreenMode);
                                        else {
                                            imageDiv.css("height", "");
                                            Utilities_1.synUtil.toggleFullscreen(imageDiv[0], function (inFullScreen) {
                                                PreviewImpl.setPrivateData($elem, "fullScreenMode", inFullScreen);
                                                setTimeout(() => tslib_1.__awaiter(this, void 0, void 0, function* () {
                                                    yield PreviewImpl.imageControlAsync($elem, imageDiv, "fit");
                                                }), 250);
                                            });
                                        }
                                    }
                                }
                            }
                        ];
                    }
                    break;
            }
            if (Utilities_1.synUtil.clientDeviceClass === "desktop" && ($.inArray(type, ["Content", "Standard"]) >= 0)) {
                let hidePreviewPrintButton;
                let typeId;
                let spl = synData.id.split("|");
                if (spl.length >= 3)
                    typeId = parseInt(spl[2], 10);
                if (!isNaN(typeId)) {
                    let hide = Utilities_1.synUtil.Configs.getValue("webtoolkithidepreviewprintbutton", undefined, typeId);
                    if (hide != undefined)
                        hidePreviewPrintButton = hide === "Y";
                }
                if (hidePreviewPrintButton == undefined)
                    hidePreviewPrintButton = Utilities_1.synUtil.Configs.getValue("webtoolkithidepreviewprintbutton", "N") === "Y";
                buttons.push({
                    img: "fa-print",
                    visibility: !hidePreviewPrintButton,
                    tooltip: "Drucken",
                    onclick() {
                        if ($workflowPane) {
                            $workflowPane.synWorkflow("printWorkflow");
                        }
                        else {
                            window.open("LegacyPreview.html?type=" + type + "&id=" + synData.id + "&print=true", "_newtab", "width=640,height=480,resizable=yes");
                        }
                    }
                });
            }
            if (type !== "Propertypage" && $workflowPane == undefined) {
                const $previewButtons = $("<div class='btn-group previewButtons'></div>")
                    .prependTo(imageDiv);
                $previewButtons.prepend($("<a href='javascript:void(0);' class='btn btn-default hide previewHeadingText' disabled='disabled'></a>"));
            }
            if (pageCount && pageCount > 1)
                PreviewImpl.setPage($elem);
            $.each(buttons, function (idx, button) {
                let ttip = button.tooltip || "";
                const $link = $("<a href='javascript:;'></a>")
                    .addClass("btn btn-default")
                    .attr("title", ttip);
                if (button.cssClass)
                    $link.addClass(button.cssClass);
                $("<i></i>").addClass("fa " + button.img).appendTo($link);
                $link.appendTo($elem.find($(".previewButtons")));
                let eventHandler = "click";
                if ("ontouchstart" in document.documentElement)
                    eventHandler = "touchstart";
                $link.bind(eventHandler, button.onclick);
                if (button.disabled)
                    $link.attr("disabled", "disabled");
                if (button.visibility === false)
                    $link.hide();
            });
        }
    }
    static imageControlAsync($elem, $targetElement, command, options) {
        return new Promise((resolve, reject) => {
            if (command === "init") {
                $targetElement.addClass("iviewer_cursor");
                $targetElement.kendoDiagram({
                    editable: false,
                    selectable: false,
                    pannable: {
                        key: "none"
                    }
                });
                let diagram = $targetElement.getKendoDiagram();
                diagram.scroller.enabled = true;
                resolve();
            }
            else {
                let diagram = $targetElement.getKendoDiagram();
                let eleWidth = $targetElement.outerWidth(false);
                let eleHeight = $targetElement.outerHeight(false);
                if (diagram) {
                    if (diagram._size) {
                        $targetElement.find(".km-scroll-wrapper").css("width", diagram._size.width + "px");
                        $targetElement.find(".km-scroll-wrapper").css("height", diagram._size.height + "px");
                    }
                    switch (command) {
                        case "loadImage":
                            // diagram.clear();
                            let img = new Image();
                            img.onerror = function () {
                                $elem.find(".previewError").removeClass("hide");
                                $elem.find(".synTabStrip, .previewButtons").addClass("hide");
                                reject();
                            };
                            img.onload = function () {
                                diagram.clear();
                                let shape = new kendo.dataviz.diagram.Shape({
                                    type: "rectangle",
                                    x: 0,
                                    y: 0,
                                    stroke: {
                                        color: "#c2c2c2",
                                        width: 1
                                    },
                                    editable: true,
                                    width: this.width,
                                    height: this.height
                                });
                                $targetElement.data("image-src", options);
                                $targetElement.data("image-width", this.width);
                                $targetElement.data("image-height", this.height);
                                $targetElement.data("shape-id", this.id);
                                let image = new kendo.dataviz.diagram.Image({
                                    source: options,
                                    x: 0,
                                    y: 0,
                                    width: this.width,
                                    height: this.height
                                });
                                shape.visual.append(image);
                                diagram.addShape(shape);
                                resolve();
                            };
                            img.src = options;
                            break;
                        case "update":
                            diagram.resize();
                            resolve();
                            break;
                        case "fit":
                            diagram.resize();
                            let imageWidth = parseInt($targetElement.data("image-width"), 10);
                            let imageHeight = parseInt($targetElement.data("image-height"), 10);
                            let zoomX = eleWidth / imageWidth;
                            let zoomY = eleHeight / imageHeight;
                            let zoomFactor = (zoomX > zoomY) ? zoomY : zoomX;
                            diagram.zoom(zoomFactor);
                            diagram.pan(new kendo.dataviz.diagram.Point(0, 0));
                            resolve();
                            break;
                        case "zoom_by":
                            diagram.zoom(diagram._zoom + (parseInt(options, 10) / 10));
                            resolve();
                            break;
                        case "set_zoom":
                            diagram.zoom(parseInt(options, 10) / 100);
                            diagram.pan(new kendo.dataviz.diagram.Point(0, 0));
                            resolve();
                            break;
                        default:
                            reject();
                            break;
                    }
                }
                else
                    reject();
            }
        });
    }
    static requestInstanceAsync($elem, id) {
        const selectedType = PreviewImpl.getPrivateData($elem, "selectedType");
        const allowedTypes = PreviewImpl.getData($elem).allowedTypes;
        const actType = selectedType || allowedTypes[0];
        let tabStrip = $elem.find(".synTabStrip").show().data("kendoTabStrip");
        let tabData = PreviewImpl.getPrivateData($elem, "tabData");
        return new Promise((resolve, reject) => {
            Utilities_1.synUtil.getAJAXData({
                url: Utilities_1.synUtil.getWSUrl("InstancePreviewTypes") + id + "/" + actType + "/all",
                done(data) {
                    $elem.find(".previewError").addClass("hide");
                    $elem.find(".synTabStrip, .previewButtons").removeClass("hide");
                    $elem.trigger("instanceLoaded");
                    if (data != undefined) {
                        tabStrip.unbind("select");
                        let tabIndex = -1;
                        let currentIndex = PreviewImpl.getTabIndexByName($elem, actType);
                        //if (currentIndex >= 0 && (_.findWhere(data, { available: true, name: actType }) || actType === "Propertypage")) {
                        if (currentIndex >= 0 && (data.find(item => item.name === actType && (item.available === true || item.isWorkFlow === true)) || actType === "Propertypage")) {
                            tabIndex = currentIndex;
                        }
                        else {
                            // Select first available tab
                            let firstAvailable = data.find(item => item.available === true || item.isWorkFlow === true);
                            if (firstAvailable)
                                tabIndex = PreviewImpl.getTabIndexByName($elem, firstAvailable.name);
                        }
                        if (tabIndex >= 0) {
                            $elem.data("initialPreviewTab", tabIndex);
                            tabStrip.select(tabIndex);
                        }
                        // enable/disable Tabs, always enable PropertyTab
                        tabStrip.enable(tabStrip.tabGroup.children().eq(PreviewImpl.getTabIndexByName($elem, "Propertypage")));
                        _.each(data, (item) => {
                            let idx = PreviewImpl.getTabIndexByName($elem, item.name);
                            if (item.pageCount)
                                tabData[idx].pageCount = item.pageCount;
                            if (item.isPlaintext)
                                tabData[idx].isPlaintext = item.isPlaintext;
                            if (item.isWorkFlow)
                                tabData[idx].isWorkFlow = item.isWorkFlow;
                            else
                                tabData[idx].isWorkFlow = false;
                            if (!item.available && !item.isWorkFlow)
                                tabStrip.disable(tabStrip.tabGroup.children().eq(idx));
                            else
                                tabStrip.enable(tabStrip.tabGroup.children().eq(idx));
                        });
                        $elem.find(".synTabStrip").show();
                        PreviewImpl.showTabContent($elem, tabIndex);
                        tabStrip.bind("select", function (e) {
                            var _a;
                            let selectedIndex = $(e.item).index();
                            PreviewImpl.setPrivateData($elem, "selectedType", (_a = PreviewImpl.getTabItemByIndex($elem, selectedIndex)) === null || _a === void 0 ? void 0 : _a.name);
                            PreviewImpl.showTabContent($elem, selectedIndex);
                        });
                    }
                    resolve();
                },
                fail: () => {
                    $elem.find(".previewError").removeClass("hide");
                    $elem.find(".synTabStrip, .previewButtons").addClass("hide");
                    reject();
                }
            });
        });
    }
    static setData($elem, data) {
        $elem.data("synPreview", data);
    }
    static getData($elem) {
        return $elem.data("synPreview");
    }
    static setPrivateData($elem, key, data) {
        $elem.data(key, data);
    }
    static getPrivateData($elem, key) {
        return $elem.data(key);
    }
    static deletePrivateData($elem, key) {
        $elem.removeData(key);
    }
}
exports.PreviewImpl = PreviewImpl;
/**
* Contains all default values for option parameters not passed by the caller
*/
PreviewImpl.DefaultOptions = {
    controls: true,
    allowedTypes: ["Content", "Standard", "Propertypage"],
    propertyPageCheckForUnsavedChanges: false,
    editable: false
};
// Dispatcher code
(($) => {
    $.fn.synPreview = function (method) {
        if (PreviewImpl[method])
            return PreviewImpl[method].apply(undefined, [this].concat(Array.prototype.slice.call(arguments, 1)));
        else if (typeof method === "object" || !method)
            return PreviewImpl.initAsync(this, arguments[0]);
        else
            $.error("Method " + method + " does not exist on jQuery.synPreview");
    };
})(jQuery);
